// ファイルシグネチャを比較する関数
const compareArray = (arr1: Uint8Array, arr2: number[]): boolean => {
  return arr1.every((value, index) => value === arr2[index]);
};
/**
 * urlが指すファイルのMIMEタイプを取得する
 * @param url ファイルのURL
 * @param callback MIMEタイプを引数に取るコールバック関数
 */
export const getMimeType = (
  url: string,
  callback: (mimeType: "application/pdf" | "image/jpeg" | "image/png" | undefined) => void
): void => {
  const urlObject = new URL(url);
  if (urlObject.protocol !== "blob:") {
    if (url.toUpperCase().includes(".PDF")) {
      return callback("application/pdf");
    }
    if (url.includes(".jpeg") || url.includes(".jpg")) {
      return callback("image/jpeg");
    }
    if (url.includes(".png")) {
      return callback("image/png");
    } else {
      return callback(undefined);
    }
  }
  fetch(url)
    .then((response) => response.blob())
    .then((blob) => {
      const reader = new FileReader();
      reader.onloadend = function () {
        // ArrayBufferからUint8Arrayに変換
        const uintArray = new Uint8Array(reader.result as ArrayBuffer);
        // ファイルシグネチャの先頭バイトを取得
        const signature = uintArray.subarray(0, 4);
        // ファイルシグネチャに基づいてMIMEタイプを判定
        let mimeType: "application/pdf" | "image/jpeg" | "image/png" | undefined;
        if (compareArray(signature, [0x89, 0x50, 0x4e, 0x47])) {
          mimeType = "image/png";
        } else if (
          compareArray(signature, [0xff, 0xd8, 0xff, 0xe0]) ||
          compareArray(signature, [0xff, 0xd8, 0xff, 0xe1])
        ) {
          mimeType = "image/jpeg";
        } else if (compareArray(signature, [0x25, 0x50, 0x44, 0x46])) {
          mimeType = "application/pdf";
        } else {
          mimeType = undefined;
        }

        callback(mimeType);
      };
      reader.readAsArrayBuffer(blob);
    })
    .catch((error) => {
      console.error("Error fetching Blob:", error);
      callback(undefined);
    });
};
